<template>
  <div class="upload-wrap">
    <img class="imgwidth" v-if="imgUrl"  :src="imgUrl" @click="showImg(imgUrl)"/>
    <Upload
      :action="baseUrl+'/file/uploadFile'"
      :on-success="setUploadInfo"
      :headers="{'Access-Token':token}"
      :show-upload-list="false"
      :format="['jpg','jpeg','png']"
      :on-format-error="handleFormatError"
    >
      <div v-if="!imgUrl" class="upload" :class="{'error-color': !validateImg}">
        <Icon type="ios-upload-outline" color="#DDDEE1" size="40" style="vertical-align: middle"></Icon>
        <p>点击上传图片</p>
      </div>
      <a v-if="!imgUrl && !validateImg" class="error-color" href="javascript:;">{{`请上传${imgName}`}}</a>
      <a v-if="imgUrl" href="javascript:;">修改</a>
    </Upload>
  </div>
 
</template>
 
<script type="text/ecmascript-6">
  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";
  export default {
    props:{
      i:{
        type:Number,
        default:0
      },
      imgName:{
        type:String,
        default:'图片'
      },
      imgUrl:{
        type:String,
        default:''
      },
      validateImg:{
        type:Boolean,
        default:true
      },
      canDelete:{
        type:Boolean,
        default:false
      }
    },
    created(){
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    },
    data () {
      return {
        baseUrl:'',
        token:'',
      };
    },
    methods:{
      setUploadInfo(response){
      
        let data = {
          res: response.data,
          index:this.i
        }
        this.$emit('setUploadInfo',data)
      },
      handleFormatError() {
        this.$Message.error('请输入jpg,jpeg,png,格式的文件')
      },
      showImg(img) {
      this.$emit('show-img',img)
    },

    }
  }
</script>
 
<style lang="css" scoped>
 .imgwidth {
  width: 167px;
  height: 118px;
  border: 0px;
}
 .upload {
  display: inline-block;
}
.upload-wrap {
  display: inline-block;
  line-height: 1;
  padding: 10px 4px;
}
.upload {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #DDDEE1;
    width: 167px;
    height: 118px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    
  }
.ivu-upload {
  position: relative;
  
}
.ivu-upload  a {
  position :absolute;
  right: 0;
  bottom: -6px;
}
a.error-color {
  color:#F56356;
  bottom: -18px;

}
</style>